FD.CONTROL = (function ($, me) {
    'use strict';

    var child = me.CONTROL || {};

    /*
    * ========================================================================
    * Private Variables
    * ========================================================================
    */
    
    var ELEM = '[data-fd="table-frozen-column"]';

    var thead;
    var tbody;
    var container;
    var frozenColumnCount;
    var frozenHeight;
    var frozenTableAfter;
    var pageScroll;
    var useWindowScroll = true;
    var setWindowScrollFunctionality = false;
    var scrollTableViewport, frozenTableViewport, scrollHeaderViewport, frozenHeaderViewport;
    var scrollTableContainer, frozenTableContainer, scrollHeaderContainer, frozenHeaderContainer;
    var frozenTableNotify = new Notify();
    var displayedTooSmallMessage = false;

    /*
    * ========================================================================
    * Private Methods
    * ========================================================================
    */

    function calculateTableHeight() {
        var maxSize = getMaxVerticalSize();
        var scrollTableContainer = $('.scroll-table-container')[0];

        return scrollTableContainer.clientHeight < maxSize ? scrollTableContainer.clientHeight : maxSize;
    }


    function calculateTableWidth() {
        return window.innerWidth < frozenTableViewport.outerWidth(true) + $('.site-left-navigation').outerWidth(true) ? 0 : window.innerWidth - frozenTableViewport.outerWidth() - $('.site-left-navigation').outerWidth(true);
    }


    // Only use if number of columns hasn't changed
    function redrawTableHead(headerHTML) {
        var thead = document.createElement('thead');
        thead.innerHTML = headerHTML.trim();

        var frozenTableHead = $('.frozen-header-container thead')[0];
        var scrollTableHead = $('.scroll-header-container thead')[0];
        $(frozenTableHead).html('');
        $(scrollTableHead).html('');

        $.each(thead.children, function (index, elem) {
            var cellIndex = 0, currentCell;
            var frozenRow = elem.cloneNode(false);
            var scrollRow = elem.cloneNode(false);
            // Check to see if the entire row is made up
            // of a single cell. If so, copy it into both tables
            if (elem.children.length === 1) {
                frozenRow.appendChild(elem.children[0].cloneNode(true));
                scrollRow.appendChild(elem.children[0]);
            } else {
                while (cellIndex < frozenColumnCount) {
                    cellIndex += elem.children[0].colSpan;
                    frozenRow.appendChild(elem.children[0]);
                }
                while (elem.children.length) {
                    scrollRow.appendChild(elem.children[0]);
                }
            }
            frozenTableHead.appendChild(frozenRow);
            scrollTableHead.appendChild(scrollRow);
        });

        recalculateFrozenTableHeadHeight(frozenTableHead.children, scrollTableHead.children, frozenHeaderViewport[0], scrollHeaderViewport[0]);
    }


    function recalculateFrozenTableHeadHeight(frozenHeaderRowList, scrollHeaderRowList, frozenHeaderHTMLViewport, scrollHeaderHTMLViewport, resetHeight) {
        var newHeaderHeight = 0;
        if (resetHeight) {
            $(frozenHeaderRowList).css("height", "");
            $(scrollHeaderRowList).css("height", "");
        }
        $(frozenHeaderRowList).each(function(x) {
            var thisRowHeight =  frozenHeaderRowList[x].offsetHeight > scrollHeaderRowList[x].offsetHeight ?
                frozenHeaderRowList[x].offsetHeight : scrollHeaderRowList[x].offsetHeight;
            newHeaderHeight += thisRowHeight;
            fastdom.mutate(function () {
                scrollHeaderRowList[x].style.height = thisRowHeight + "px";
                frozenHeaderRowList[x].style.height = thisRowHeight + "px";
            });
        });
        fastdom.mutate(function() {
            frozenHeaderHTMLViewport.style.height = newHeaderHeight + 'px';
            scrollHeaderHTMLViewport.style.height = newHeaderHeight + 'px';
        });
        return newHeaderHeight;
    }


    function recalculateFrozenTableBodyHeight(frozenBodyRowList, scrollBodyRowList, resetHeight) {
        if (resetHeight) {
            $(frozenBodyRowList).css("height", "");
            $(scrollBodyRowList).css("height", "");
        }
        $(frozenBodyRowList).each(function (x) {
            fastdom.measure(function () {
                var thisRowHeight = frozenBodyRowList[x].offsetHeight > scrollBodyRowList[x].offsetHeight ?
                    frozenBodyRowList[x].offsetHeight : scrollBodyRowList[x].offsetHeight;
                fastdom.mutate(function () {
                    scrollBodyRowList[x].style.height = thisRowHeight + "px";
                    frozenBodyRowList[x].style.height = thisRowHeight + "px";
                });
            });
        });
    }


    function recalculateFrozenTableViewport() {
        fastdom.measure(function () {
            var tableWidth = calculateTableWidth(),
                headerHeight = scrollTableViewport.css("top");
            var scrollbarHeight = $('.scroll-table-viewport').height() - $('.scroll-table-viewport')[0].clientHeight;

            fastdom.mutate(function () {
                scrollTableViewport.width(tableWidth);
                scrollHeaderViewport.width(tableWidth - 16);
                scrollTableViewport.css("height", "calc(" + frozenHeight + "vh - " + headerHeight + ")");
                frozenTableViewport.css("height", "calc(" + frozenHeight + "vh - " + headerHeight + ")");
                frozenTableAfter.css("margin-top", frozenHeight + "vh");

                if ($(".scroll-table-container").height() > $('.scroll-table-viewport').height()) {
                    $('.frozen-table-viewport').height($('.scroll-table-viewport').height() + scrollbarHeight);
                }
            });
        });
    }


    // Only use if number of columns hasn't changed
    function redrawTableBody(bodyHTML) { 
        var tbody = document.createElement('tbody');
        tbody.innerHTML = bodyHTML.trim();

        var frozenTableBody = $('.frozen-table-container tbody'),
            scrollTableBody = $('.scroll-table-container tbody');

        frozenTableBody.html('');
        scrollTableBody.html('');

        $.each(tbody.children, function (index, elem) {
            var cellIndex = 0;
            var frozenRow = elem.cloneNode(false);
            var scrollRow = elem.cloneNode(false);
            // Check to see if the entire row is a single cell. If so, it needs to be copied
            // into both table panes (usually this is the "No records found" row).
            if (elem.children.length === 1) {
                frozenRow.appendChild(elem.children[0].cloneNode(true));
                scrollRow.appendChild(elem.children[0]);
            } else {
                while (cellIndex < frozenColumnCount) {
                    cellIndex += elem.children[0].colSpan;
                    frozenRow.appendChild(elem.children[0]);
                }
                while (elem.children.length) {
                    scrollRow.appendChild(elem.children[0]);
                }
            }
            frozenTableBody.append(frozenRow);
            scrollTableBody.append(scrollRow);
        });

        recalculateFrozenTableBodyHeight(frozenTableBody.children(), scrollTableBody.children());
        recalculateFrozenTableViewport();
        
        $('.scroll-table-viewport input').on('mouseenter', function () {
            useWindowScroll = true;
        }).on('mouseleave', function () {
            useWindowScroll = false;
        });
    }


    function getMaxVerticalSize() {
        return window.innerHeight - $('.site-top-navigation').outerHeight(true) - $('.site-fixed-top-content ').outerHeight(true) - scrollHeaderViewport.outerHeight(true) - 3;
    }


    function handleResize() {
        var frozenHeaderHTMLViewport = frozenHeaderViewport[0],
            scrollHeaderHTMLViewport = scrollHeaderViewport[0],
            frozenBodyHTMLViewport = frozenTableViewport[0],
            scrollBodyHTMLViewport = scrollTableViewport[0];
        frozenHeaderHTMLViewport.style.top = ($('.site-top-navigation').outerHeight(true) + $('.site-fixed-top-content ').outerHeight(true)) + 'px';
        scrollHeaderHTMLViewport.style.top = ($('.site-top-navigation').outerHeight(true) + $('.site-fixed-top-content ').outerHeight(true)) + 'px';
        frozenBodyHTMLViewport.style.top = (parseFloat(frozenHeaderHTMLViewport.style.top) + parseFloat(frozenHeaderHTMLViewport.style.height)) + 'px';
        scrollBodyHTMLViewport.style.top = (parseFloat(frozenHeaderHTMLViewport.style.top) + parseFloat(frozenHeaderHTMLViewport.style.height)) + 'px';
        recalculateFrozenTableViewport();
        if (scrollTableViewport.width() === 0) {
            if (!displayedTooSmallMessage) {
                var label = me.getLabel();
                frozenTableNotify.alert(label['ScreenToSmall']);
                displayedTooSmallMessage = true;
            }
        } else {
            displayedTooSmallMessage = false;
        }
    }

    /*
    * ========================================================================
    * Public Methods
    * ========================================================================
    */

    //  set table resize
    child.setTableFrozenColumn = function (table) {
        if (!(table instanceof jQuery)) {
            table = table ? $(table) : $(ELEM);
        }
        if (!table.length) {
            return;
        }

        frozenColumnCount = +table.data('frozencount');
        frozenHeight = +table.data('frozenheight') > 0 ? +table.data('frozenheight') : 100;
        frozenTableAfter = $(".table-frozen-after");
        pageScroll = table.data("pagescroll") === undefined ? true : table.data("pagescroll");
        
        // Step 1: Size Table Correctly
        // Split up headers into frozen and scrollable tables
        var frozenHeaderRowList = [],
            scrollHeaderRowList = [],
            frozenColgroup = document.createElement('colgroup'),
            scrollColgroup = document.createElement('colgroup'),
            frozenTableWidth = 0,
            scrollTableWidth = 0;

        $.each(table.find('thead tr'), function (index, elem) {
            var headerIndex = 0, col, currentHeader;
            frozenHeaderRowList.push(elem.cloneNode(false));
            scrollHeaderRowList.push(elem.cloneNode(false));
            for (; headerIndex < frozenColumnCount;) {
                if (elem.children[0].dataset.width) {
                    col = document.createElement('col');
                    col.setAttribute('width', elem.children[0].dataset.width);
                    frozenColgroup.appendChild(col);
                    frozenTableWidth += +elem.children[0].dataset.width;
                }
                headerIndex += elem.children[0].colSpan;
                frozenHeaderRowList[index].appendChild(elem.children[0]);
            }
            while (elem.children.length) {
                if (elem.children[0].dataset.width) {
                    col = document.createElement('col');
                    col.setAttribute('width', elem.children[0].dataset.width);
                    scrollColgroup.appendChild(col);
                    scrollTableWidth += +elem.children[0].dataset.width;
                }
                scrollHeaderRowList[index].appendChild(elem.children[0]);
            }
        });

        // Upper left corner - frozen table headers
        var frozenThead = document.createElement('thead');
        for (var j = 0; j < frozenHeaderRowList.length; j++) {
            frozenThead.appendChild(frozenHeaderRowList[j]);
        }

        var frozenHeaderTableElement = document.createElement('table');
        frozenHeaderTableElement.className = 'fd-table pr-0';
        frozenHeaderTableElement.appendChild(frozenColgroup.cloneNode(true));
        frozenHeaderTableElement.appendChild(frozenThead);

        var frozenHeaderHTMLContainer = document.createElement('div');
        frozenHeaderHTMLContainer.className = 'frozen-header-container';
        frozenHeaderHTMLContainer.style.top = 0;
        frozenHeaderHTMLContainer.style.left = 0;
        frozenHeaderHTMLContainer.style.width = frozenTableWidth + 'px';
        frozenHeaderHTMLContainer.appendChild(frozenHeaderTableElement);

        var frozenHeaderHTMLViewport = document.createElement('div');
        frozenHeaderHTMLViewport.className = 'frozen-header-viewport';
        frozenHeaderHTMLViewport.style.top = ($('.site-top-navigation').outerHeight(true) + $('.site-fixed-top-content ').outerHeight(true)) + 'px';
        frozenHeaderHTMLViewport.style.left = '0';
        frozenHeaderHTMLViewport.style.width = frozenTableWidth + 'px';
        frozenHeaderHTMLViewport.appendChild(frozenHeaderHTMLContainer);

        // Upper right corner - scrollable table headers
        var scrollThead = document.createElement('thead');
        for (var k = 0; k < scrollHeaderRowList.length; k++) {
            scrollThead.appendChild(scrollHeaderRowList[k]);
        }
        var scrollHeaderTableElement = document.createElement('table');
        scrollHeaderTableElement.className = 'fd-table pr-0';
        scrollHeaderTableElement.appendChild(scrollColgroup.cloneNode(true));
        scrollHeaderTableElement.appendChild(scrollThead);

        var scrollHeaderHTMLContainer = document.createElement('div');
        scrollHeaderHTMLContainer.className = 'scroll-header-container';
        scrollHeaderHTMLContainer.style.top = 0;
        scrollHeaderHTMLContainer.style.left = 0;
        scrollHeaderHTMLContainer.style.width = scrollTableWidth + 'px';
        scrollHeaderHTMLContainer.appendChild(scrollHeaderTableElement);

        var scrollHeaderHTMLViewport = document.createElement('div');
        scrollHeaderHTMLViewport.className = 'scroll-header-viewport';
        scrollHeaderHTMLViewport.style.top = ($('.site-top-navigation').outerHeight(true) + $('.site-fixed-top-content ').outerHeight(true)) + 'px';
        scrollHeaderHTMLViewport.style.left = frozenHeaderHTMLViewport.style.width;
        scrollHeaderHTMLViewport.style.width = scrollTableWidth + "px";
        // width is caluclated farther down based on screen size
        scrollHeaderHTMLViewport.appendChild(scrollHeaderHTMLContainer);

        // Add headers to page so we can calculate their height now that column sizes are different
        var bodyContent = $('.site-body-content')[0];
        bodyContent.appendChild(frozenHeaderHTMLViewport);
        bodyContent.appendChild(scrollHeaderHTMLViewport);

        var newRowHeight = recalculateFrozenTableHeadHeight(frozenHeaderRowList, scrollHeaderRowList, frozenHeaderHTMLViewport, scrollHeaderHTMLViewport)

        // Body
        var frozenBodyRowList = [],
            scrollBodyRowList = [];

        $.each(table.find('tbody tr'), function (index, elem) {
            var cellIndex = 0, currentCell;
            frozenBodyRowList.push(elem.cloneNode(false));
            scrollBodyRowList.push(elem.cloneNode(false));
            // Check to see if the entire row is a single cell. If so, it needs to be copied
            // into both table panes (usually this is the "No records found" row).
            if (elem.children.length === 1) {
                frozenBodyRowList[index].appendChild(elem.children[0].cloneNode(true));
                scrollBodyRowList[index].appendChild(elem.children[0]);
            } else {
                while (cellIndex < frozenColumnCount) {
                    cellIndex += elem.children[0].colSpan;
                    frozenBodyRowList[index].appendChild(elem.children[0]);
                }
                while (elem.children.length) {
                    scrollBodyRowList[index].appendChild(elem.children[0]);
                }
            }
        });

        // Bottom left corner - frozen table columns
        var frozenTbody = document.createElement('tbody');
        for (var l = 0; l < frozenBodyRowList.length; l++) {
            frozenTbody.appendChild(frozenBodyRowList[l]);
        }

        var frozenBodyTableElement = document.createElement('table');
        frozenBodyTableElement.className = 'fd-table pr-0';
        frozenBodyTableElement.appendChild(frozenColgroup);
        frozenBodyTableElement.appendChild(frozenTbody);

        var frozenBodyHTMLContainer = document.createElement('div');
        frozenBodyHTMLContainer.className = 'frozen-table-container';
        frozenBodyHTMLContainer.style.top = 0;
        frozenBodyHTMLContainer.style.left = 0;
        frozenBodyHTMLContainer.style.width = frozenTableWidth + 'px';
        frozenBodyHTMLContainer.appendChild(frozenBodyTableElement);

        var frozenBodyHTMLViewport = document.createElement('div');
        frozenBodyHTMLViewport.className = 'frozen-table-viewport';
        frozenBodyHTMLViewport.style.top = (parseFloat(frozenHeaderHTMLViewport.style.top) + newRowHeight) + 'px';
        frozenBodyHTMLViewport.style.left = '0';
        frozenBodyHTMLViewport.style.width = frozenTableWidth + 'px';
        // Height gets calculated farther down based on window size
        frozenBodyHTMLViewport.appendChild(frozenBodyHTMLContainer);

        // Bottom right corner - scrollable table columns
        var scrollTbody = document.createElement('tbody');
        if ($('tbody', table).data('fd') === 'excel-navigation') {
            $(scrollTbody).attr('data-fd', 'excel-navigation');
        }
        for (var x = 0; x < scrollBodyRowList.length; x++) {
            scrollTbody.appendChild(scrollBodyRowList[x]);
        }

        var scrollBodyTableElement = document.createElement('table');
        scrollBodyTableElement.className = 'fd-table pr-0';
        scrollBodyTableElement.appendChild(scrollColgroup);
        scrollBodyTableElement.appendChild(scrollTbody);

        var scrollBodyHTMLContainer = document.createElement('div');
        scrollBodyHTMLContainer.className = 'scroll-table-container';
        scrollBodyHTMLContainer.style.top = 0;
        scrollBodyHTMLContainer.style.left = 0;
        scrollBodyHTMLContainer.style.width = scrollTableWidth + 'px';
        scrollBodyHTMLContainer.appendChild(scrollBodyTableElement);

        var scrollBodyHTMLViewport = document.createElement('div');
        scrollBodyHTMLViewport.className = 'scroll-table-viewport';
        scrollBodyHTMLViewport.style.top = (parseFloat(frozenHeaderHTMLViewport.style.top) + newRowHeight) + 'px';
        scrollBodyHTMLViewport.style.left = frozenHeaderHTMLViewport.style.width;
        // Height and width get calculated farther down
        scrollBodyHTMLViewport.appendChild(scrollBodyHTMLContainer);

        bodyContent.appendChild(frozenBodyHTMLViewport);
        bodyContent.appendChild(scrollBodyHTMLViewport);

        recalculateFrozenTableBodyHeight(frozenBodyRowList, scrollBodyRowList);

        $(table).remove();

        // Save frequently referenced elements
        scrollHeaderViewport = $('.scroll-header-viewport');
        scrollHeaderContainer = scrollHeaderViewport.find('div');
        scrollTableViewport = $('.scroll-table-viewport');
        scrollTableContainer = scrollTableViewport.find('div');
        frozenHeaderViewport = $('.frozen-header-viewport');
        frozenHeaderContainer = frozenHeaderViewport.find('div');
        frozenTableViewport = $('.frozen-table-viewport');
        frozenTableContainer = frozenTableViewport.find('div');

        recalculateFrozenTableViewport();

        // Setup event listeners
        var syncRight, syncLeft;
        $('.scroll-table-viewport').off('scroll').on('scroll', function () {
            if (!syncRight) {
                syncLeft = true;
                var top = $(this).scrollTop();
                var left = $(this).scrollLeft();

                if ($.browser.msedge || $.browser.msie) {
                    var obj = $(this)[0];
                    var scrollPercent = obj.scrollTop / (obj.scrollHeight - obj.clientHeight);
                    if (true) {
                        top += 10 * scrollPercent;
                    }
                }

                frozenTableViewport.scrollTop(top);
                scrollHeaderViewport.scrollLeft(left);
            }
            syncRight = false;
        });
        $('.frozen-table-viewport').off('scroll').on('scroll', function () {
            if (!syncLeft) {
                syncRight = true;
                var top = $(this).scrollTop();

                if ($.browser.msedge || $.browser.msie) {
                    var obj = $(this)[0];
                    var scrollPercent = obj.scrollTop / (obj.scrollHeight - obj.clientHeight);
                    if (true) {
                        top -= 10 * scrollPercent;
                    }
                }

                scrollTableViewport.scrollTop(top);
            }
            syncLeft = false;
        });
        if (pageScroll) {
            $('.scroll-table-viewport,.frozen-table-viewport').on('mouseenter', function (event) {
                useWindowScroll = false;
            }).on('mouseleave', function () {
                useWindowScroll = true;
            });
            $('.scroll-table-viewport input').on('mouseenter', function () {
                useWindowScroll = true;
            }).on('mouseleave', function () {
                useWindowScroll = false;
            });
        }

        if (!setWindowScrollFunctionality) {
            window.addEventListener('wheel', function (event) {
                if (pageScroll && useWindowScroll && $(event.target).parents('[data-fd="scroll"]').length === 0) {
                    // Firefox reports deltaY in lines instead of pixels
                    if (event.deltaMode === 1) {
                        scrollTableViewport
                            .scrollTop(Math.floor(scrollTableViewport.scrollTop() + event.deltaY * 40))
                            .scrollLeft(Math.floor(scrollTableViewport.scrollLeft() + event.deltaX)).scroll();
                    } else {
                        scrollTableViewport
                            .scrollTop(Math.floor(scrollTableViewport.scrollTop() + event.deltaY))
                            .scrollLeft(Math.floor(scrollTableViewport.scrollLeft() + event.deltaX)).scroll();
                    }
                }
            });

            setWindowScrollFunctionality = true;
        }

        $(window).off('resize.frozentable', handleResize).on('resize.frozentable', handleResize);
    };


    child.redrawFrozenTableBody = function (bodyHTML) {
        redrawTableBody(bodyHTML);
    };


    child.redrawFrozenTableHead = function (headHTML) {
        redrawTableHead(headHTML);
    };


    // Recalculate total height of table (usually after adding/removing rows) to see if the horizontal scroll bar needs to be repositioned
    child.recalculateFrozenTableHeight = function () {
        var frozenTableBody = frozenTableContainer.find('tbody')[0],
            scrollTableBody = scrollTableContainer.find('tbody')[0],
            frozenTableHead = $('.frozen-header-container thead')[0],
            scrollTableHead = $('.scroll-header-container thead')[0];

        recalculateFrozenTableHeadHeight(frozenTableHead.children, scrollTableHead.children, frozenHeaderViewport[0], scrollHeaderViewport[0], true);
        recalculateFrozenTableBodyHeight(frozenTableBody.children, scrollTableBody.children, true);

        recalculateFrozenTableViewport();
    };

    
    child.showScrollTableColumns = function (startCol, endCol) {
        var self = this;
        var useRange = (startCol >= 0 && endCol >= 0);

        //  get width of table
        var thMainList = scrollHeaderContainer.find('[data-width]');
        thMainList.each(function (i) {
            if (!useRange || (this.cellIndex >= startCol && this.cellIndex <= endCol)) {
                $(this).removeClass('hidden');
            }

            if (!$(this).hasClass('hidden')) {
                self._tableWidth += parseInt($(this).width());
                scrollTableContainer.find("tr td:nth-child(" + (this.cellIndex + 1) + ")").removeClass('hidden');
                scrollHeaderContainer.find("colgroup col:nth-child(" + (this.cellIndex + 1) + ")").removeClass('hidden');
            }
        });
        $('[data-noresults=true] td', scrollTableContainer).attr('colspan', thMainList.filter(":visible").length);

        child.recalculateScrollTableWidth();
    };
    // Hide columns in range
    child.hideScrollTableColumns = function (startCol, endCol) {
        var self = this;

        var thMainList = scrollHeaderContainer.find('[data-width]');
        thMainList.each(function (i) {
            if (i >= startCol && i <= endCol) {
                $(this).addClass('hidden');
                scrollTableContainer.find("tr td:nth-child(" + (this.cellIndex + 1) + ")").addClass('hidden');
                scrollHeaderContainer.find("colgroup col:nth-child(" + (this.cellIndex + 1) + ")").addClass('hidden');
            }
        });
        $('[data-noresults=true] td', scrollTableContainer).attr('colspan', thMainList.filter(":visible").length);

        child.recalculateScrollTableWidth();
    };
    // Recalculate width of scrolling table container (usually after hiding/showing columns) to see if the horizontal scroll bar should be adjusted
    child.recalculateScrollTableWidth = function () {
        var scrollTableWidth = 0;
        scrollHeaderContainer.find('[data-width]:not(.hidden)').each(function () {
            scrollTableWidth += +this.dataset.width;
        });
        scrollHeaderContainer[0].style.width = scrollTableWidth + "px";
        scrollTableContainer[0].style.width = scrollTableWidth + "px";
    };


    // Recalcualte the table frames, viewport, and scrollbars.
    child.recalculateFrozenTableViewport = function () {
        handleResize();
    }
    

    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));